import Store from 'store/store';

Store.on('SHOW_SERVICE_AREA', (bool) => {
	Store.get().serviceArea.set({
		showServiceArea: bool
	});
});
